function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9352 25.7958L12.9352 2.07416",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.61 12.9284L12.9892 2.07482",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.26045 12.9283L12.9891 2.07476",
  stroke: "#F0F0F5",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.6292 14.9057L32.6114 14.8985C32.4191 14.8985 32.2241 14.9173 32.0354 14.8914C31.4665 14.8118 30.9853 14.589 31.0005 13.92C31.0149 13.251 31.4817 13.0238 32.0765 13.022C34.216 13.014 32.6866 13.014 33.7752 13.022C39.0388 13.0229 44.3043 13.0301 49.5679 13.0238C51.2441 13.0211 52.4471 11.8333 52.4265 10.2475C52.4077 8.75116 51.2003 7.56963 49.6941 7.5741C48.1798 7.57857 46.975 8.83971 47.0206 10.3772C47.0269 10.5686 47.0645 10.7591 47.0779 10.9505C47.119 11.5346 46.8918 11.9505 46.2845 12.0391C45.6745 12.1276 45.315 11.7806 45.2139 11.2153C45.0314 10.201 45.1128 9.2091 45.5878 8.26817C46.5958 6.27719 48.746 5.29333 50.9078 5.84519C52.9873 6.37558 54.3755 8.29232 54.3012 10.5293C54.2315 12.658 52.6904 14.4665 50.5107 14.7912C49.381 14.9602 48.2156 14.9182 47.0662 14.9245C44.2542 14.9414 41.4412 14.9298 38.6292 14.9298V14.9057Z",
  fill: "#F0F0F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5343 17.2116C41.1281 17.2116 43.7228 17.2125 46.3166 17.2107C48.0572 17.2107 49.516 18.4405 49.6582 20.063C49.8362 22.1067 48.7387 23.3312 46.9231 23.6863C45.2085 24.0208 43.6379 22.9073 43.2872 21.1935C43.1808 20.6703 43.3677 20.2875 43.8704 20.1122C44.3713 19.9378 44.7621 20.1265 45.0242 20.5782C45.0841 20.681 45.1154 20.8 45.1611 20.91C45.4625 21.6318 45.9991 21.9359 46.6842 21.774C47.4257 21.5978 47.8577 21.0263 47.7862 20.3152C47.7173 19.6256 47.1654 19.1185 46.4052 19.1131C44.0994 19.0988 41.7936 19.1069 39.4877 19.1069C36.5353 19.1078 35.5399 19.0818 32.5883 19.0818C32.4434 19.0818 32.2985 19.0908 32.1563 19.0738C31.5973 19.0085 31.1903 18.75 31.1483 18.1436C31.1134 17.6329 31.5731 17.2196 32.2109 17.2116C33.794 17.1937 33.42 17.2304 35.0031 17.2295C36.1802 17.2286 37.3572 17.2286 38.5343 17.2286V17.2116Z",
  fill: "#F0F0F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.1173 10.7488C33.5565 10.7488 33.9512 10.7557 32.3913 10.7459C31.6257 10.7414 31.1526 10.3863 31.14 9.84698C31.1266 9.27007 31.6186 8.87564 32.4074 8.87385C35.4333 8.86937 36.5036 8.8777 39.5295 8.87323C40.3496 8.87144 40.9328 8.38667 41.0017 7.68902C41.0714 6.98779 40.6233 6.35812 39.9302 6.18371C39.2575 6.01466 38.6467 6.37869 38.3265 7.18457C38.0993 7.75521 37.7442 8.06199 37.1145 7.87506C36.5287 7.70065 36.3346 7.17383 36.568 6.46008C36.9589 5.25977 38.1538 4.3421 39.423 4.26607C40.7781 4.18557 42.0607 4.95567 42.6054 6.17924C43.5704 8.34731 42.0455 10.7256 39.6582 10.7515C38.1449 10.7685 36.6306 10.7551 35.1173 10.7551V10.7488Z",
  fill: "#F0F0F5"
});

function SvgWindS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindS);
export default __webpack_public_path__ + "static/media/wind-S.a21ef8cc.svg";
export { ForwardRef as ReactComponent };